<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">人员调动审批申请表</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn">返回</a>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="100px" class="form">

          <create-transfer-approval ref="create" :project="project" :userData="userData" :formByFather="form">
          </create-transfer-approval>

          <div class="tip" style="margin:20px 0 0 40px">
            * 相关附件
          </div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments :projectId="form.projectId" :contractId="form.contractId" ref="attachments"
                :arr="attachmentArr" :type='990'></attachments>
            </el-form-item>
          </div>


          <div class="tip" style="margin:20px 0 0 40px">
            * 意见与审批
          </div>
          <div class="clear label-mx">

            <el-form-item label="审批方式">
              <div class="approve">
                <el-radio v-model="approvalType" label="0">顺序审批</el-radio>
                <el-radio v-model="approvalType" label="1">平行审批</el-radio>
              </div>
            </el-form-item>

            <!-- 审批 -->
            <approval-item ref="approval" :approvalUsers="approvalUsers.c102" :selectArr="selectArr"
              :approvalSetDep="approvalSetDep"></approval-item>

          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createProject()" class="form-btn" type="success">确认人员调动审批申请表
              </el-button>
            </div>
          </el-form-item>

        </el-form>
      </el-col>
    </div>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";
  import Attachments from '@/components/Attachments'

  import approvalUsers from '@/Mixins/approvalUsers'
  import ApprovalItem from '@/components/ApprovalItem'
  // import ApprovalItemByCustom from '../../components/ApprovalItemByCustom'

  import CreateTransferApproval from '@/page/form/personnel/createTransferApproval'
  export default {
    components: {
      ApprovalItem,
      CreateTransferApproval,
      Attachments,
    },
    mixins: [approvalUsers],
    computed: {
      ...mapState({
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        hasApplyId: '',
        contractType: 1,

        project: {},
        form: {
          "inDepId": "",
          "inPosition": "",
          "outDepId": "",
          "outPosition": "",
          "reason": "",
          "transferTime": "",
          "archivesId": '',
          json: true,
        },
        // approvalUsersData: "",

        // 审批
        approvalType: "0",
        formLoading: false,

        applyInfo: '',
        attachmentArr: [],

        approvalSetDep: {},
      }
    },
    created() {
      if (this.$route.query.applyId) {
        this.form.applyId = this.$route.query.applyId / 1
      }
      // if (this.$route.query.userId) {
      //   this.form.archivesId = this.$route.query.userId / 1
      // }
    },
    mounted() {
      this.getApplyData()
    },
    methods: {
      // 获取审批表原内容
      getApplyData() {
        this.hasApplyId = this.form.applyId ? true : false
        if (this.form.applyId) {
          this.formLoading = true
          this.getProjectApplyInfo()
        } else {
          this.applyInfo = ''
          this.setSelectArr(this.applyInfo, 102)
        }
      },
      // 获取原审批表内容
      getProjectApplyInfo() {
        ajax.get('/human/transfer/apply/info/' + this.form.applyId, '', (res) => {
          this.form = res.vo
          this.applyInfo = res.vo
          this.form.applyId = this.form.flow.applyId
          this.form.json = true
          this.form.archivesId = res.vo.userArchives.archivesId

          this.attachmentArr = this.form.attachments ? this.form.attachments : []
          this.setSelectArr(this.applyInfo, 102)
          this.formLoading = false
        })
      },
      // 提交申请
      createProject() {
        this.form = this.$refs.create.getFromData()

        // if (!this.form.content) {
        //   this.$message.error('人员调动审批必须填写审批原因')
        //   return
        // }
        if (!this.form.transferTime) {
          this.$message.error('人员调动审批必须选择调动时间安排')
          return
        }

        this.form.approvalType = this.approvalType
        this.form.approvalUserIds = this.$refs.approval.getUserIds()
        this.form.attachments = this.$refs.attachments.getAttachments()

        console.log(this.form.approvalUserIds)
        this.formLoading = true
        let _url = !this.form.applyId ? '/human/transfer/apply' : '/human/transfer/apply/edit?applyId=' + this.form
          .applyId

        ajax.post(_url, this.form, (res) => {
          this.$message.success("提交审批成功，请耐心等待领导审批")
          this.$router.push("/Personnel/Transfer/List")
          this.formLoading = false
        }, (res) => {
          this.formLoading = false
        })
      },
    },
    watch: {}
  };
</script>


// WEBPACK FOOTER //
// src/page/personnel/transferApply.vue